<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="distance-report" *ngIf="reportService.reportData.length > 0">
    <thead>
        <tr>
            <th>ID</th>
            <th>{{ level_info?.second_level_name?level_info?.second_level_name:'DSM' }} Name</th>
            <th>{{ level_info?.third_level_name?level_info?.third_level_name:'ASM' }} Name</th>
            <th>District</th>
            <th>City</th>
            <th [hidden]="_wssp_ids_based">{{ level_info?.fourth_level_name?level_info?.fourth_level_name:'Distribution' }}</th>
            <th>Vehicle No</th>
            <th>Vehicle Type</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Total Distance</th>
            <th>Total Out Hours</th>
        </tr>
    </thead>
    <tbody>
        <tr class="table-border-double" *ngFor="let distance of reportService.reportData; let i=index" [ngStyle]="{'background-color': distance.row_color, 'color':distance.font_color}">
            <td>{{ distance.level1 }}</td>
            <td>{{ distance.level2 }}</td>
            <td>{{ distance.level3 }}</td>
            <td>{{ distance.state }}&nbsp;</td>
            <td>{{ distance.city }}&nbsp;</td>
            <td [hidden]="_wssp_ids_based">{{ distance.level4 }}</td>
            <td>{{ distance.plate_no }}</td>
            <td>{{ distance.vehicle_model }}</td>
            <td *ngIf=" distance.start_time">{{  distance.start_time | date : 'hh:mm:ss a' }}</td>
            <td *ngIf="! distance.start_time"></td>
            <td *ngIf=" distance.end_time">{{  distance.end_time | date : 'hh:mm:ss a' }}</td>
            <td *ngIf="! distance.end_time"></td>
            <td>{{ distance.total_distance }}</td>
            <td>{{ distance.total_moving_time }}</td>
        </tr>
    </tbody>
</table>
